export const drawables = {
  general: {
    Ic_Accessibility_Pictoservicios: require('./icons/Ic_Accessibility_Pictoservicios.png'),
    Ic_Accessibility: require('./icons/Ic_Accessibility-Pictoservicios.svg').ReactComponent,
    Ic_Add : require('./icons/Ic_Add.svg').ReactComponent,
    Ic_arrow_left : require('./icons/Ic_arrow_left.svg').ReactComponent,
    Ic_Arrow_Right : require('./icons/Ic_Arrow_Right.svg').ReactComponent,
    Ic_Buho_Urbano: require('./icons/Ic_Buho_Urbano.png'),
    Ic_Bus : require('./icons/Ic_Bus.svg').ReactComponent,
    Ic_Bus_CRTM_Fill: require('./icons/Ic_Bus_CRTM_Fill.png'),
    Ic_Cercanias: require('./icons/Ic_Cercanias.png'),
    Ic_close : require('./icons/Ic_close.svg').ReactComponent,
    Ic_HomeFill : require('./icons/Ic_HomeFill.svg').ReactComponent,
    Ic_Info : require('./icons/Ic_Info.svg').ReactComponent,
    Ic_Informacion : require('./icons/Ic_Informacion.svg').ReactComponent,
    Ic_Less : require('./icons/Ic_Less.svg').ReactComponent,
    Ic_Link : require('./icons/Ic_Link.svg').ReactComponent,
    Ic_Logo : require('./icons/Ic_Logo.svg').ReactComponent,
    Ic_Pin : require('./icons/Ic_planificar.svg').ReactComponent,
    Ic_Reset : require('./icons/Ic_Reset.svg').ReactComponent,
    Ic_Share : require('./icons/Ic_Share.svg').ReactComponent,
    Ic_Star : require('./icons/Ic_Star--outlined.svg').ReactComponent,
    Ic_Ubi : require('./icons/Ic_Ubi.svg').ReactComponent,
    Ic_warningC : require('./icons/Ic_warningC.svg').ReactComponent,
    Ic_error : require('./icons/Ic_error.svg').ReactComponent,
    Ic_success : require('./icons/Ic_Checkmark_Circle.svg').ReactComponent,
    Ic_infoC : require('./icons/Ic_infoC.svg').ReactComponent,
    Ic_changeOriDest : require('./icons/Ic_changeOriDest.svg').ReactComponent,
    Ic_Ticket : require('./icons/Ic_Ticket.svg').ReactComponent,
    Ic_Walk : require('./icons/Ic_walk.svg').ReactComponent,
    Ic_chevron_down : require('./icons/Ic_chevron--down.svg').ReactComponent,
    Ic_chevron_up : require('./icons/Ic_chevron--up.svg').ReactComponent,
    Ic_Download : require('./icons/Ic_Download.svg').ReactComponent,
    Ic_Origin : require('./icons/Ic_location--filled.svg').ReactComponent,
    Ic_Destination : require('./icons/Ic_Flag--filled.svg').ReactComponent,
    Ic_Caret_Down : require('./icons/Ic_caret--down.svg').ReactComponent,
    Ic_Caret_Up : require('./icons/Ic_caret--up.svg').ReactComponent,
    Ic_tick : require('./icons/Ic_tick.svg').ReactComponent,
    Ic_Info_gray: require('./icons/Ic_Informacion--filled.svg').ReactComponent,
    IC_arrow_direction: require('./icons/direction_arrow_up.png'),
    Ic_Menu: require('./icons/Ic_Menu.svg').ReactComponent,
  },
  map:{
    your_location : require('./icons/your_location.png'),
    Ic_your_ubi : require('./icons/Ic_your_ubi.svg').ReactComponent,
    Ic_your_location : require('./icons/Ic_your_location.svg').ReactComponent,
    Ic_location: require('./icons/Ic_location.svg').ReactComponent,
    0 : require('./icons/origin.png'),
    1 : require('./icons/destination.png'),

  }

};
